<template>
    <section class="mod mod1">
        <!-- 加统计图-开始 -->
        <!-- <div class="nav-sub flex">
            <span v-for="(item, i) in ZJHistoryNavs" :key="i" :class="curZJHistory == i ? 'cur' : ''" @click="tableInfo(i)">
                {{ item }}
            </span>
        </div> -->
        <div class="nav-sub-cont">
            <div class="chart-legent flex">
                <span
                    v-for="(title, i) in legents"
                    :key="i"
                    class="legent-blue legent"
                    >{{ title }}</span
                >
                <!-- <div class="legent-more legent" @click="showKLMore = !showKLMore" :class="showKLMore ? 'down' : ''">
                    <span class="legent-black legent">{{ KLMoreArray[KLMoreIndex] }}</span>
                    <ul v-show="showKLMore">
                        <li v-for="(title, i) in KLMoreArray" :class="KLMoreIndex == i ? 'actived' : ''" :key="i" @click="setZs(i)">
                            {{ title }}
                        </li>
                    </ul>
                </div> -->
                <!-- <div class="legent-more" @click="showKLMore2 = !showKLMore2" :class="showKLMore2 ? 'down' : ''">
                    <span class="legent">{{ ZJHistoryNavs[curZJHistory] }}</span>
                    <ul v-show="showKLMore2">
                        <li v-for="(title, i) in ZJHistoryNavs" :class="curZJHistory == i ? 'actived' : ''" :key="i" @click="tableInfo(i)">
                            {{ title }}
                        </li>
                    </ul>
                </div> -->
            </div>
            <div v-if="showInfo">
                <div class="chart chart-jigou" id="jline"></div>
            </div>

            <div
                style="
                    height: 1.5rem;
                    text-align: center;
                    line-height: 1.5rem;
                    font-size: 14px;
                    color: #999999;
                "
                v-else
            >
                -暂无数据-
            </div>
        </div>
        <!-- 加统计图-结束 -->
        <!-- <div class="nav2">
            <div class="nav2-wrap flex">
                <span v-for="(nav, i) in bkNavs" :key="i" :class="curBKNav == i ? 'cur' : ''" @click="navClick(i)">{{ nav }}</span>
            </div>
        </div> -->

        <div class="table-scroll table-scroll-h" v-show="curBKNav == 0">
            <div class="table-l fl">
                <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                        <th>机构名称</th>
                    </tr>
                    <tr
                        v-for="(item, index) in topTenList"
                        :key="index"
                        @click="gotoJigou(item.particode, item.compname)"
                    >
                        <!-- <td>{{item.compname}}</td> -->
                        <td>
                            <div
                                style="
                                    text-overflow: -o-ellipsis-lastline;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 2;
                                    line-clamp: 2;
                                    -webkit-box-orient: vertical;
                                "
                            >
                                {{ item.compname }}
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="table-r">
                <div class="table-r-wrap table-r-jg">
                    <table width="100%" cellspacing="0" cellpadding="0">
                        <tr>
                            <th
                                :class="
                                    sortname == index
                                        ? sorttype == 1
                                            ? 'sort'
                                            : 'sort up'
                                        : ''
                                "
                                @click="keySort(index)"
                                v-for="(item, index) in cctitle"
                                :key="index"
                            >
                                {{ item }}
                            </th>
                        </tr>
                        <tr
                            v-for="(item, index) in topTenList"
                            :key="index"
                            @click="gotoJigou(item.particode, item.compname)"
                        >
                            <!-- <td :class="item.rate|formateRedGreen">{{item.rate}}%</td> -->
                            <td>{{ item.holdamt | formateSum }}</td>
                            <!-- <td :class="item.cbuyamt | formateRedGreen">{{ item.cbuyamt | formateSum }}</td> -->
                            <!-- <td>{{ item.continuity }}</td> -->

                            <td>{{ item.holdstk }}</td>
                            <td>{{ item.maxholdnm }}</td>
                            <td>{{ item.maxaddnm }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <!-- <div class="table-scroll table-scroll-h" v-show="curBKNav == 1">
            <div class="table-l fl">
                <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                        <th>机构名称</th>
                    </tr>
                    <tr v-for="(item, index) in topTenList" :key="index" @click="gotoJigou(item.particode, item.compname)">
                        <td>
                            <div style="text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;line-clamp: 2;-webkit-box-orient: vertical;">
                                {{ item.compname }}
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="table-r">
                <div class="table-r-wrap  table-r-wrap2 table-r-jg">
                    <table width="100%" cellspacing="0" cellpadding="0">
                        <tr>
                            <th v-for="(item, index) in jmtitle" :key="index" :class="sortname == index ? sorttype == 1 ? 'sort' : 'sort up' : ''" @click="keySort(index)">{{ item }}
                            </th>
                        </tr>
                        <tr v-for="(item, index) in topTenList" :key="index" @click="gotoJigou(item.particode, item.compname)">
                            <!~~ <td :class="item.rate|formateRedGreen">{{item.rate}}%</td> ~~>
                            <td :class="item.cbuyamt | formateRedGreen">{{ item.cbuyamt | formateSum }}</td>
                            <td>{{ item.holdamt | formateSum }}</td>
                            <td>{{ item.continuity }}</td>
                            <td>{{ item.holdstk }}</td>
                            <td>{{ item.maxholdnm }}</td>
                            <td>{{ item.maxaddnm }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>-->

        <!--<div class="table-scroll table-scroll-h" v-show="curBKNav == 2">
            <div class="table-l fl">
                <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                        <th>机构名称</th>
                    </tr>
                    <tr v-for="(item, index) in topTenList" :key="index" @click="gotoJigou(item.particode, item.compname)">
                        <td>
                            <div style="text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;line-clamp: 2;-webkit-box-orient: vertical;">
                                {{ item.compname }}
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="table-r">
                <div class="table-r-wrap  table-r-wrap2 table-r-jg">
                    <table width="100%" cellspacing="0" cellpadding="0">
                        <tr>
                            <th v-for="(item, index) in lxtitle" :key="index" :class="sortname == index ? sorttype == 1 ? 'sort' : 'sort up' : ''" @click="keySort(index)">
                                {{ item }}
                            </th>
                        </tr>
                        <tr v-for="(item, index) in topTenList" :key="index" @click="gotoJigou(item.particode, item.compname)">
                            <!~~ <td :class="item.rate|formateRedGreen">{{item.rate}}%</td> ~~>
                            <td>{{ item.continuity }}</td>
                            <td>{{ item.holdamt | formateSum }}</td>
                            <td :class="item.cbuyamt | formateRedGreen">{{ item.cbuyamt | formateSum }}</td>
                            <td>{{ item.holdstk }}</td>
                            <td>{{ item.maxholdnm }}</td>
                            <td>{{ item.maxaddnm }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>-->
        <div
            v-if="nullStatus"
            style="text-align: center; padding: 15px 10px"
            @click="jgGengduo()"
        >
            点击加载更多
        </div>
    </section>
</template>

<script>
import { jgList } from "@/api/int.js";
import { getUrlQuery } from "@/utils/handleUrl.js";
import { getHolderValue } from "@/api/xqDetail.js";
export default {
    name: "JiGou",
    components: {},
    //
    data() {
        return {
            nullStatus: true,
            userToken: "",
            sortfield: "holdamt", //排序字段
            sorttype: "1", //正序倒叙
            sortname: "holdamt",
            pagesize: 20,
            page: 1,
            curBKNav: 0,
            bkNavs: ["持仓榜", "净仓榜", "持续增仓榜"],
            topTenList: [],
            todayDate: "自定义日期",
            curDateIndex: 0,
            dateList: ["近5日", "近20日", "近60日", "近120日"],
            // cctitle: {
            //     'holdamt': '持仓市值', 'cbuyamt': '净买额', 'continuity': '连续增仓', 'holdstk': '持仓股票',
            //     'maxholdnm': '持仓最多', 'maxaddnm': '增持最多'
            // },
            cctitle: {
                holdamt: "持仓市值",
                holdstk: "持仓股票",
                maxholdnm: "持仓最多",
                maxaddnm: "增持最多",
            },

            jmtitle: {
                cbuyamt: "净买额",
                holdamt: "持仓市值",
                continuity: "连续增仓",
                holdstk: "持仓股票",
                maxholdnm: "持仓最多",
                maxaddnm: "增持最多",
            },

            lxtitle: {
                continuity: "连续增仓",
                holdamt: "持仓市值",
                cbuyamt: "净买额",
                holdstk: "持仓股票",
                maxholdnm: "持仓最多",
                maxaddnm: "增持最多",
            },
            legents: ["机构持仓总市值"],
            showKLMore: false,
            KLMoreIndex: 0,
            KLMoreArray: ["上证指数", "深证成指", "创业板指", "沪深300"],
            setZsTitle: "上证指数",
            curZJHistory: 0,
            ZJHistoryNavs: ["近一月", "近三月", "近半年"],
            showInfo: true,
            token: "",
            obj: "SH000001",
            type: "1",
            dataInfo: [],
            dataInfo2: [],
            dayObj: {
                categoryData: [],
                amt: [],
                sum: [],
                // K线
                values: [],
            },
            myChart: "",
            month: 1,
            showKLMore2: false,
        };
    },
    filters: {
        formateTag: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "交易中";
            if (v < 0) return "已结束";
        },
        formatePrefixData: function (v) {
            if (v == undefined || v == null) return "--";
            if (v > 0) return "+" + v;
            if (v < 0) return v;
        },
        formateRedGreen: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "ft-red";
            if (v < 0) return "ft-green";
        },
        formateSum: function (v) {
            if (Math.abs(v) < 100000000) {
                return (v / 10000).toFixed(2) + "万";
            } else {
                return (v / 100000000).toFixed(2) + "亿";
            }
        },
        getbh: function (v) {
            //v 单位万元
            if ((v < 10000 && v > 0) || v < 0) {
                return v.toFixed(2) + "万";
            } else if (v >= 10000) {
                return (v / 10000).toFixed(2) + "亿";
            } else {
                return "0";
            }
        },
    },
    created() {
        this.userToken = getUrlQuery("token");
    },
    mounted: function () {
        this.getList();
        this.token = getUrlQuery("token");
        // 获取数据
        this.getJgzjData();
    },
    methods: {
        getList: function () {
            // var start = (this.page-1) * this.pagesize + 1;
            // console.log(this.pagesize);
            jgList({
                pageNumber: this.page,
                pageSize: this.pagesize,
                sortfield: this.sortfield,
                sorttype: this.sorttype,
                token: this.userToken,
            }).then((res) => {
                // console.log();
                if (
                    res.data.err != 0 ||
                    res.data.data.list.length < this.pagesize
                ) {
                    this.nullStatus = false;
                } else {
                    res.data.data.list.forEach((element) => {
                        this.topTenList.push(element);
                    });
                    this.page = this.page + 1;
                }
            });
        },
        navClick: function (i) {
            this.nullStatus = true;
            if (i == 0 && i != this.curBKNav) {
                this.page = 1;
                this.sortfield = "holdamt";
                this.sortname = "holdamt";
                this.sorttype = "1";
                this.topTenList = [];

                this.getList();
            } else if (i == 1 && i != this.curBKNav) {
                this.page = 1;
                this.sortfield = "cbuyamt";
                this.sortname = "cbuyamt";

                this.sorttype = "1";
                this.topTenList = [];

                this.getList();
            } else if (i == 2 && i != this.curBKNav) {
                this.page = 1;
                this.sortfield = "continuity";
                this.sortname = "continuity";

                this.sorttype = "1";
                this.topTenList = [];

                this.getList();
            }

            this.curBKNav = i;
        },
        keySort: function (index) {
            if (index == "maxholdnm" || index == "maxaddnm") {
                return false;
            }
            this.sortname = index;

            if (this.sorttype == 1) {
                this.sorttype = 0;
            } else {
                this.sorttype = 1;
            }

            this.sortfield = index;
            this.page = 1;

            this.topTenList = [];

            this.getList();
        },
        jgGengduo: function () {
            this.getList();
        },
        gotoJigou: function (particode, name) {
            location.href =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                "#/jgdetail?code=" +
                particode +
                "&DZHSPECIAL=264&name=" +
                name;
            // this.$router.push('/jgdetail?code='+particode+"&DZHSPECIAL=264");
        },
        /**
         * 图表数据
         */
        getJgzjData: function () {
            var _this = this;
            var params = {
                token: _this.token,
                month: _this.month,
                obj: _this.obj,
            };
            getHolderValue(params).then((res) => {
                if (res.data.err == 0) {
                    // _this.dataInfo2 = res.data.data;
                    let response = res.data.data;
                    for (var i = 0; i < response.length; i++) {
                        response[i].holdamt = (
                            response[i].holdamt / 100000000
                        ).toFixed(2);
                    }
                    _this.dataInfo2 = response;
                    this.$nextTick(() => {
                        setTimeout(function () {
                            _this.drawKL();
                        }, 300);
                    });
                }
            });
        },
        /**
         * 图表渲染
         */
        drawKL: function () {
            var _this = this;

            var chartDom = document.getElementById("jline");
            _this.myChart = this.$echarts.init(chartDom);
            var option;

            var data = _this.dataInfo2;
            // 拆分
            var dayObj = splitData(data);
            function splitData(rawData) {
                // tradedate
                var categoryData = [];
                var values = [];
                var objamt = [];
                for (var i = 0; i < rawData.length; i++) {
                    categoryData.push(rawData[i].tradedate);
                    values.push(rawData[i].holdamt);
                    objamt.push(rawData[i].objamt);
                }
                return {
                    categoryData: categoryData,
                    values: values,
                    objamt: objamt,
                };
            }
            option = {
                grid: [
                    {
                        containLabel: true, //防止坐标轴标签溢出
                        show: true,
                        left: 0,
                        right: 0,
                        top: 20,
                        bottom: 0,
                        borderWidth: 0,
                    },
                ],
                axisPointer: {
                    link: { xAxisIndex: "all" },
                    lineStyle: {
                        color: "#666",
                        width: 1,
                    },
                },
                // 提示框组件
                tooltip: {
                    trigger: "axis",
                    triggerOn: "mousemove",
                    position: function (point) {
                        // 固定在底部
                        return [point[0] / 2, "30%"];
                    },
                    textStyle: {
                        fontSize: 12,
                        lineHeight: 22,
                    },
                },
                // 横轴组件
                xAxis: [
                    {
                        type: "category",
                        data: dayObj.categoryData,
                        position: "bottom",
                        boundaryGap: true,
                        axisLine: { show: false },
                        axisTick: { show: false },
                        axisLabel: {
                            interval: function (index) {
                                var timeLength = dayObj.categoryData.length - 1;
                                if (index == 0) {
                                    return true;
                                }
                                if (index == timeLength) {
                                    return true;
                                }
                            },
                            formatter: function (value, index) {
                                //文本格式化
                                if (index === 0) {
                                    return "{right|" + value + "}";
                                } else {
                                    return "{left|" + value + "}";
                                }
                            },
                            rich: {
                                right: {
                                    width: 100,
                                    fontSize: 10,
                                    align: "right",
                                },
                                left: {
                                    width: 100,
                                    fontSize: 10,
                                    align: "left",
                                },
                                center: {
                                    fontSize: 10,
                                    align: "center",
                                },
                            },
                            // padding: [0, 20, 0, 0],
                        },
                    },
                ],
                // 纵轴组件
                yAxis: [
                    {
                        type: "value",
                        scale: true, //自动适配y轴，不需要必须从0开始 或者选择下边这种设置最大最小值
                        position: "left", //坐标轴位置，移至右边
                        // type: 'category',

                        // axisLabel: {
                        //     fontSize: 10,
                        //     color: "#999",
                        //     inside: true,
                        //     verticalAlign: "bottom",
                        //     margin: 3,
                        //     padding: [1, 0],
                        //     formatter:'{value}亿'
                        // },
                    },
                ],
                series: [
                    {
                        name: "持仓市值（亿）",
                        type: "bar",
                        // smooth: true,
                        symbolSize: 0,
                        barWidth: "60%",
                        itemStyle: {
                            normal: {
                                color: "#1677FF",
                                color0: "#fd6761",
                                borderColor: "#1677FF",
                                borderColor0: "#fd6761",
                            },
                            emphasis: {
                                borderWidth: 1,
                            },
                        },
                        data: dayObj.values,
                        yAxisIndex: 0,
                    },
                ],
            };

            // 使用刚指定的配置项和数据显示图表。
            _this.myChart.setOption(option);
            window.addEventListener("resize", function () {
                _this.myChart.resize();
            });
        },
        /**
         * 重新加载图表尺寸
         */
        chartResize: function () {
            var _this = this;
            // this.drawKL();
            // this.getJgzjData();
            this.$nextTick(() => {
                _this.myChart.resize();
            });
        },
        /**
         * 切换表头
         */
        tableInfo: function (i) {
            this.curZJHistory = i;
            if (i == 0) {
                this.type = 1;
                this.month = 1;
            } else if (i == 1) {
                this.type = 2;
                this.month = 3;
            } else {
                this.type = 3;
                this.month = 6;
            }
            this.getJgzjData();
        },
        /**
         * 切换指数
         */
        setZs: function (i) {
            this.KLMoreIndex = i;
            if (i == 0) {
                // 上证
                this.obj = "SH000001";
            } else if (i == 1) {
                // 深证
                this.obj = "SZ399001";
            } else if (i == 2) {
                //创业板指
                this.obj = "SZ399006";
            } else {
                this.obj = "SH000300";
            }
            this.getJgzjData();
        },
    },
};
</script>
